import { useContext } from 'react'
import { PermissionsContext, PermissionsContextType } from '@src/components/permissions'

export const usePagePermissions = (): PermissionsContextType => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider')
  }
  return context
}
  